module.exports = __webpack_public_path__ + "static/media/FCE_ERDF.b815499a.png";